import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DEFAULT_COLORS } from '../constants';
import type { ChartLegendItemProps } from '.';

export const LegendItemComponent = ({ item, index }: ChartLegendItemProps) => (
  <Box
    className="star-rating-categories-legend-item"
    sx={{
      '--legend-hover-color': item.color ?? DEFAULT_COLORS[index],
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      listStyle: 'none',
      paddingY: '12px',
      borderBottom: '1px solid',
      borderColor: 'neutral.lighter2',
      '&:hover': {
        borderColor: 'var(--legend-hover-color)',
      },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: '50px',
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          display: 'inline-block',
          width: '14px',
          height: '14px',
          backgroundColor: item.color ?? DEFAULT_COLORS[index],
          borderRadius: '4px',
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: '16px',
          fontWeight: '500',
          marginLeft: '8px',
          color: 'neutral.darker',
        }}
      >
        {item.label}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
      <Typography sx={{ fontSize: '16px', color: 'neutral.dark' }}>{item.value}%</Typography>
    </Box>
  </Box>
);
